import React from 'react'
import moment from "moment";
import { useTranslation } from 'react-i18next';

export const WalletCard = ({item}: {item: any}) => {
    const {t} = useTranslation();
    const formatDate = (utcTime: any) => {
        const date = new Date(utcTime);
        const formattedDate = moment(date)?.format("YYYY-MM-DD");
        return formattedDate;
      };
    
      return (
        <div className="max-w-[400px] w-full p-5 border border-secondary border-opacity-[0.05] rounded-[10px] shadow">
          <p className='flex-1 font-bold'>{item?.clubDetails?.name}</p>
          <p className='flex-1 font-semibold mt-0.5'>
            {t("totalAvailableCredits")}: {item?.clubCreditDetails?.credit}
          </p>
          <div className='flex justify-between gap-2.5 mt-2 text-sm text-center font-medium'>
            <p className='flex-1'>{t("purchasedCredits")}</p>
            <p className='flex-1'>{t("remainingCredits")}</p>
            <p className='flex-1'>{t("expirationDate")}</p>
          </div>
          {item?.purchasedCredits?.map((val: any, index: number) => (
            <div key={index} className='flex justify-between gap-2.5 text-center font-medium break-words text-sm'>
              <p className='flex-1'>{val?.purchased_credits}</p>
              <p className='flex-1'>{val?.remaining_credits }</p>
              <p className='flex-1'>{formatDate(val?.expire_at)}</p>
            </div>
          ))}
        </div>
      )
}
